export const safeParse = (data: any, errFn?: (value) => void) => {
  try {
    return JSON.parse(data);
  } catch (err) {
    if (errFn) {
      return errFn(err);
    } else {
      console.error(err);
    }
  }
};
